import compressFetchParams from 'my-core/compress-api-fetch-params';
import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function fetchCourseApi(courseId, fetchParams, requestKey) {
  return standardApiRequestAction({
    method: 'get',
    path: `/api/v1/courses/${courseId}`,
    body: compressFetchParams(fetchParams),
    requestKey,
  });
}

export function fetchCoursesApi(fetchParams, requestKey, page, cacheGroupKey) {
  return standardApiRequestAction({
    path: '/api/v1/courses',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
    cacheGroupKey,
  });
}

export function fetchLibraryCoursesV2(fetchParams, requestKey) {
  return standardApiRequestAction({
    path: '/api/v1/courses/library_v2',
    body: fetchParams,
    requestKey,
  });
}

export function searchCourses(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/courses/search',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function createCourse(body) {
  return standardApiRequestAction({
    path: '/api/v1/courses',
    method: 'post',
    body,
  });
}

export function updateCourse(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${id}`,
    method: 'patch',
    body,
  });
}

export function deleteCourse(id) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${id}`,
    method: 'delete',
    destroy: { courses: [id] },
  });
}

export function fetchForStudent(studentId, fetchKey) {
  return standardApiRequestAction({
    path: '/api/v1/courses/student',
    body: { user_id: studentId },
    requestKey: fetchKey,
  });
}

export function fetchCourseProgress(courseIdOrSlug, params, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseIdOrSlug}/my_progress`,
    body: params,
    requestKey,
  });
}

export function fetchCourseMyStudyPlanner(courseIdOrSlug, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseIdOrSlug}/my_study_planner`,
    requestKey,
  });
}

export function fetchCourseQuestionBankStats(courseSlug, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseSlug}/question_bank_stats`,
    requestKey,
  });
}

// INSTRUCTOR

export function fetchInstructorCourses(instructorId, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/instructor_dashboard/${instructorId}`,
    body: fetchParams,
    requestKey,
  });
}

export function fetchCopyableCoursesApi(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/courses/for_copying',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function fetchCourseManagerReviewContents(courseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseId}/manager_review`,
    requestKey,
  });
}

export function fetchCourseManagerBuildContents(courseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseId}/manager_build`,
    requestKey,
  });
}

export function fetchCourseManagerClassRepContents(courseId, semester, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseId}/manager_class_reps`,
    requestKey,
    body: { semester },
  });
}

// TEACHER

export function fetchTeacherCourses(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/courses/teacher_dashboard',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function createTeacherCourse(body) {
  return standardApiRequestAction({
    path: '/api/v1/courses/teacher_course',
    method: 'post',
    body,
  });
}

// ADMIN

export function csvUpload(file) {
  return standardApiRequestAction({
    path: '/api/v1/courses/csv_upload',
    method: 'postFormData',
    body: { file },
  });
}

export function mergeCourses(origId, targetId) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${origId}/merge`,
    method: 'put',
    body: { target_id: targetId },
    destroy: { courses: [targetId] },
  });
}
